import { CircularProgress, Dialog } from '@mui/material';
import { dissoc } from 'ramda';
import { Dispatch, FC, SetStateAction } from 'react';
import { GetAuthorsQuery_query_authors_Author } from '../../../__generated__/queries-web';
import { useGetAuthor } from '../../../apollo/queries/authors.web.graphql';
import { EditContent } from './EditContent';
import { AuthorContext, initialState } from './types';

interface FormDialogProps {
  isOpen: boolean;
  isFullScreen: boolean;
  shouldUseDebounce?: boolean;
  author?: AuthorContext;
  searchId?: string;
  handleClose: () => void;
  title?: string;
  setAuthor: Dispatch<
    SetStateAction<GetAuthorsQuery_query_authors_Author[] | []>
  >;
}
export const FormDialog: FC<FormDialogProps> = ({
  isFullScreen,
  isOpen,
  handleClose,
  author,
  shouldUseDebounce = true,
  searchId,
  title = 'Modifier un auteur',
  setAuthor,
}) => {
  let authorToDisplay = author || initialState;
  let loadingMessage;
  const { loading, data } = useGetAuthor(searchId || '');

  if (loading) {
    loadingMessage = (
      <div data-testid="waitingIcon">
        <CircularProgress />
      </div>
    );
  }
  if (data && data.author) {
    authorToDisplay = dissoc('__typename', data.author) as AuthorContext;
  }

  return (
    <Dialog fullScreen={isFullScreen} open={isOpen} onClose={handleClose}>
      {loadingMessage || (
        <EditContent
          shouldUseDebounce={shouldUseDebounce}
          author={authorToDisplay as AuthorContext}
          handleClose={handleClose}
          title={title}
          setAuthor={setAuthor}
        />
      )}
    </Dialog>
  );
};
